module.exports = __webpack_public_path__ + "img/dice-3.36a35a16.svg";